import classNames from 'classnames';
import React from 'react';

interface LabelProps {
  htmlFor?: string;
  children: any;
  className?: string;
}

const Label = ({ htmlFor, children, className }: LabelProps) => {
  return (
    <label htmlFor={htmlFor} className={classNames('control-label control-label--v2', className)}>
      {children}
    </label>
  );
};

export default Label;
